import { Component, OnInit, OnDestroy } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LanguageTranslateService } from "src/app/_services/language-translate.service";
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { AssetService } from "src/app/_services/asset.service";
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ErrorUtil } from "src/app/_utilities/error";
import { UtilServiceService } from "src/app/_services/utilService/util-service.service";

@Component({
  selector: "app-select-existing-contract-in-block",
  standalone: false,
  templateUrl: "./select-existing-contract-in-block.component.html",
  styleUrl: "./select-existing-contract-in-block.component.scss",
})
export class SelectExistingContractInBlockComponent
  extends SubscriptionUtil
  implements OnInit, OnDestroy
{
  translate: any;
  data: any;
  contracts: any[] = [];
  selectedContract: any;
  displayTable: boolean = false;
  selectContractForm!: FormGroup;

  constructor(
    public modalRef: BsModalRef,
    private modalServc: BsModalService,
    private languageTranslateService: LanguageTranslateService,
    private assetServc: AssetService,
    private errorUtil: ErrorUtil,
    private util: UtilServiceService
  ) {
    super();
  }

  ngOnInit(): void {
    this.getLanguageData();
    this.selectContractForm = new FormGroup({
      contract: new FormControl(null, [Validators.required]),
    });
  }

  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
        }
      }),
    );
  }

  push(obs: any) {
    super.push(obs);
  }

  getContractsFirstWay(event: any) {
    const query = event.query;

    if (query != null && query.length > 0) {
      this.push(
        this.assetServc
          .getContractGrid(0, 25, query, null, null)
          .subscribe((res: any) => {
            this.contracts = res.body?.data ? res.body.data : [];
          }),
      );
    }
  }

  gotSelectedContract(valueContract: any) {
    var val = valueContract.value ? valueContract.value : valueContract;
    this.contracts = [val];

    this.selectedContract = val;
    this.selectContractForm.patchValue({ contract: val.contractNumber });
    this.displayTable = false;
  }

  clearValue() {
    this.selectedContract = null;
    this.selectContractForm.controls["contract"].reset();
    this.selectContractForm.controls["contract"].updateValueAndValidity();
    this.contracts = [];
  }

  showTable() {
    this.displayTable = !this.displayTable;
  }

  closeContractView() {
    this.displayTable = false;
  }

  onUseThisContract() {
    if (this.selectContractForm.valid && this.selectedContract) {
      //call GET contract by id to get complete info
      this.assetServc.getViewContract(this.selectedContract.id).subscribe({
        next: (response: any) => {
          let contractInfo: any = response.body;
          contractInfo["startDate"] = this.util.formatISOStringToDate(
            contractInfo.startDateTime,
          );
          contractInfo.endDate = this.util.formatISOStringToDate(
            contractInfo.endDateTime,
          );

          let jsonObj: any = {
            layer: this.data?.layer,
            reason: "contractCreated",
            contract: contractInfo,
          };
          this.modalServc.setDismissReason(JSON.stringify(jsonObj));
          this.modalRef.hide();
        },
        error: (error: any) => {
          let errorTitle: string = error.error.title;
          this.errorUtil.setErrorMessage(
            error.status,
            null,
            errorTitle,
            "error",
            2000,
          );
        },
      });
    } else {
      this.selectContractForm.markAllAsTouched();
    }
  }

  onCreateContract() {
     let jsonObj: any = {
      layer: this.data?.layer,
      reason: "createdFromExistingModal"
    };
    this.modalServc.setDismissReason(JSON.stringify(jsonObj));
    this.modalRef.hide();
  }
}
